import { ModuleDataType } from 'types/interfacePreviewTypes';

export const wippe_cii_schwarz_l: ModuleDataType = {
  outputPdf: null,
  userUploadedFilesDescriptions: [],
  userUploadedFiles: [],
  id: null,
  projectTitle: '',
  configuratorPreviewScreenshot: null,
  isSubmitted: false,
  createdAt: null,
  updatedAt: null,
  userInfo: {
    name: '',
    lastname: '',
    firma: '',
    email: '',
    telephoneNumber: '',
    clientNumber: null,
    comments: '',
    country: '',
    postalCode: '',
  },

  background: {
    active: true,
    type: 'image',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/miunskekonfigurator.appspot.com/o/images%2Fwippen-images%2Fmar-2-2025%2Fcii_schwarz_l.png?alt=media&token=d7609056-84c6-403d-9bc2-65ae2f2fae90',
    thumbnail: null,
  },

  rotation: '0',
  module: 'Contura II - Wippe schwarz mit Linse weiß',
  version: '1.0',

  elements: {
    symbols: {
      0: {
        active: false,
        color: '#0e1111',
        icon: null,

        variant: 'bottom',
      },
      1: {
        active: true,
        color: '#0e1111',
        icon: null,
        variant: 'top',
      },
    },
  },
};
